import { ChangePasswordPage } from './ChangePasswordPage';
import { withChangePasswordPage } from './withChangePasswordPage';

const ConnectedChangePasswordPage = withChangePasswordPage(ChangePasswordPage);

export { ConnectedChangePasswordPage as ChangePasswordPage };
